export class AdminDashboardModel {

  public therapistsAvailable?: number;
  public waitTimeMinutes?: number;
  public bookingsInQueue?: number;
  public bookingsInProgress?: number;
  public bookingsCompleted?: number;
  public bookingsCancelled?: number;
  public therapistsOnBreak?: number;
  public clockedInCount?: number;
  public onMassageCount?: number;
  public waiting?: number;
  public therapistsAtEvent?: number;
}
